module.exports = __webpack_public_path__ + "media/search/office_grayscale-2968531d.png";